import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import {
  TrendingUp,
  Clock,
  UserCheck,
  CheckCircle,
  AlertTriangle,
  Shield
} from 'lucide-react';

const metrics = [
  {
    icon: TrendingUp,
    value: '99.9%',
    label: 'Risk Identification Rate',
    description: 'Comprehensive coverage of potential hazards'
  },
  {
    icon: Clock,
    value: '60%',
    label: 'Time Reduction',
    description: 'Faster study completion compared to traditional methods'
  },
  {
    icon: UserCheck,
    value: '5000+',
    label: 'Safety Professionals',
    description: 'Active users worldwide'
  },
  {
    icon: CheckCircle,
    value: '10000+',
    label: 'Studies Completed',
    description: 'Successful HAZOP studies conducted'
  },
  {
    icon: AlertTriangle,
    value: '45000+',
    label: 'Hazards Identified',
    description: 'Potential risks discovered and mitigated'
  },
  {
    icon: Shield,
    value: '100%',
    label: 'Compliance Rate',
    description: 'Meeting industry safety standards'
  }
];

export default function SafetyMetrics() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  return (
    // <section className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
    <section className="py-20 bg-gradient-to-br from-black to-slate-900 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Safety Excellence in Numbers
          </h2>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Our platform has helped organizations worldwide achieve exceptional
            safety performance through digital transformation.
          </p>
        </div>

        <div 
          ref={ref}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {metrics.map((metric, index) => {
            const Icon = metric.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gradient-to-br from-black to-slate-900 backdrop-blur-lg rounded-xl p-6 border border-white/20"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-black to-slate-900 rounded-lg flex items-center justify-center">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold text-white">
                      {metric.value}
                    </h3>
                    <p className="text-white font-medium">
                      {metric.label}
                    </p>
                  </div>
                </div>
                <p className="text-white">
                  {metric.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}